import React, { Component } from 'react';
import axios from 'axios';
import withRouter from '../../Utils/withRouter';
import { formatDate, formatTime, convertTo12HourFormat, getHoursAndMinutes, isNegativeDeviation, TextBox, getDaysDifference, SubmitButton } from '../../Components/InputElements';
import PageTitle from "../../Components/PageTitle";
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx'
import Select from 'react-select';
import { NoRecords } from '../../Components/Shimmer';
import { currentDateAndTime, formatDateAndTime, tableFormatDateAndTime, getFullYearMonthArray } from '../../Constants/constants';
import { decodeData } from '../../Constants/constants';

class TeamRegularization extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            employee_id: 0,
            employee_attendance_id: 0,
            attendance_regularization_request_id: 0,
            remark_by_manager: '',
            employee_code: "",
            employee_name: "",
            punch_in_datetime: "",
            punch_out_datetime: "",
            rows: [],
            rz_data: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            loadingFilter: false,
            keyword: "",
            from_date: "",
            to_date: "",
            selectOption: "",
            month: parseInt(currentDateAndTime()?.split(" ")[0]?.split("-")[1]),
            monthOptions: [],
            selectedRows: [],
            checkAll: false,
            multi_action: false,
            decodedData: [],
        };
        this.modalRef = React.createRef();
        this.closeRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
            this.GetRegularizationSettings();
        });
        let date = currentDateAndTime();
        let monthOpt = getFullYearMonthArray(date);
        this.setState({ monthOptions: monthOpt })
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.permissions !== this.context.permissions) {
        // console.log("Permissions Updated:", this.context.permissions);
            const { permissions } = this.context;
            if (permissions.length > 0) {
            const queryParams = new URLSearchParams(window.location.search);
            const encodedData = queryParams.get("abs");
            const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
            if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                this.setState({ decodedData });
            }
            } else {
            console.warn("Permissions not yet available. Retrying...");
            }
        }
    }
    formatGetedDateTime = (dateTimeString) => {
        const date = new Date(dateTimeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }




    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        //   GetMyTeamAttendance  
        axios.get(`${apiURL}Attendance/GetTeamRegularizationReport`, {
            params: {
                limit: this.state.limit,
                page: this.state.page,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                regularization_status: this.state.selectOption,
                month: this.state.month,
                date: currentDateAndTime(),
            },
            headers,
        }).then((response) => {
            // console.log("GetList ~ response", response);
            let data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    multi_action: data.rm_multi_action,
                });
            }
            this.setState({ loadingList: false, loadingFilter: false });
        })
        .catch((error)=>{
        console.log(error);
        this.setState({ loadingList: false, loadingFilter: false });
        Swal.fire({ 
        title: `<strong>Failed</strong>`, 
        text: error?.message, 
        icon: 'error', 
        showConfirmButton: true,
        allowOutsideClick:false, 
        });
        });
    };

    GetRegularizationLogs = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationLogs`, {
            params: {
                attendance_regularization_request_id: this.state.attendance_regularization_request_id,
            }, headers
        }).then((response) => {
            console.log("GetRegularizationLogs ~ response", response);
            const { data, success } = response.data;
            if (success === true) {
                this.setState({
                    logs_data: data,
                });
            }
        });
    }

    GetRegularizationSettings = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Attendance/GetRegularizationSettings`, { headers }).then((response) => {
            const { data, success } = response.data;
            if (success === true && data.length != 0) {
                this.setState({
                    rz_data: data[0],
                });
            }
        });
    }

    GetInfo = (row, employeeIndex) => {
        if (this.state.rows[employeeIndex]?.regularization_request_remark) {
            let reqInAndOut = JSON.parse(this.state.rows[employeeIndex]?.regularization_request_remark);
            let punchInDateTime = reqInAndOut.punch_in_datetime;
            let punchOutDateTime = reqInAndOut.punch_out_datetime;
            let formattedPunchInDateTime = formatDateAndTime(punchInDateTime, 12);
            formattedPunchInDateTime = `${formattedPunchInDateTime?.split("T")[0]} ${formattedPunchInDateTime?.split("T")[1]}`;

            // Format punch_out_datetime only if it's not null
            let formattedPunchOutDateTime = null;
            if (punchOutDateTime !== null) {
                formattedPunchOutDateTime = formatDateAndTime(punchOutDateTime, 12);
                formattedPunchOutDateTime = `${formattedPunchOutDateTime?.split("T")[0]} ${formattedPunchOutDateTime?.split("T")[1]}`;
            }
            this.setState({
                punch_in_datetime: formattedPunchInDateTime,
                punch_out_datetime: formattedPunchOutDateTime,
                employee_id: row.employee_id,
                employee_code: row.employee_code,
                employee_name: row.employee_name,
                employee_attendance_id: row.employee_attendance_id,
                attendance_regularization_request_id: row.attendance_regularization_request_id,
                modal_type: 1,
                selectedRows: [] 
                // remark_by_manager: data[0].remark_by_manager,
            });
        }
    }

    // handleCheckboxChange = (attendanceRegularizationRequestId) => {
    //     this.setState((prevState) => {
    //         const selectedRows = [...prevState.selectedRows];
    //         const index = selectedRows.findIndex(row => row.attendance_regularization_request_id === attendanceRegularizationRequestId);

    //         if (index > -1) {
    //             console.log("index", index);
    //             selectedRows.splice(index, 1);
    //         } else {
    //             console.log("attendanceRegularizationRequestId", attendanceRegularizationRequestId);
    //             selectedRows.push(attendanceRegularizationRequestId);
    //         }
    //         return { selectedRows }, () => {
    //             // Callback after setState to access updated state
    //             console.log("Updated selectedRows: ", this.state.selectedRows);
    //         }
    //     });
    // };

    handleCheckboxChange = (attendanceRegularizationRequestId) => {
        this.setState((prevState) => {
            // Copy the previous selectedRows state
            const selectedRows = [...prevState.selectedRows];

            // Find the index of the attendanceRegularizationRequestId in the selectedRows array
            const index = selectedRows.findIndex(row => row === attendanceRegularizationRequestId);

            // If the id exists, remove it; otherwise, add it
            if (index > -1) {
                selectedRows.splice(index, 1);
            } else {
                selectedRows.push(attendanceRegularizationRequestId);
            }

            // Return the updated selectedRows state
            return { selectedRows };
        }, () => {
            // Callback after setState to access the updated state
            console.log("Updated selectedRows: ", this.state.selectedRows);
        });
    };

    handleSelectAllCheckboxChange = (isChecked) => {
        if (isChecked) {
            this.setState((prevState) => {
                const selectedRows = prevState.rows
                    .filter(row => row.regularization_request_status === 0 && (getDaysDifference(formatDate(row.created_date)) <= this.state.rz_data.days_for_rm_action))
                    .map(row => (row.attendance_regularization_request_id));
                return { selectedRows, checkAll: true };
            }, () => {
                // Callback after setState to access updated state
                console.log("Updated selectedRows: ", this.state.selectedRows);
            });
        } else {
            this.setState({ selectedRows: [], checkAll: false }, () => {
                // Callback after setState to access updated state
                console.log("Updated selectedRows: ", this.state.selectedRows);
            });
        }
    };


    RegularizationActionAccept = (e) => {
        e.preventDefault()
        const { apiURL, apiHeaderJSON } = this.context;
        if (this.state.selectedRows?.length >= 1) {
            Swal.fire({
                title: 'Submit Remark',
                input: 'text',
                inputPlaceholder: 'Enter your Remark',
                showCancelButton: true,
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                // inputValidator: (value) => {
                //     if (!value) {
                //         return 'Remark cannot be empty';
                //     }
                // },
            }).then((result) => {
                if (result.isConfirmed) {
                    var formData = {};

                    if (this.state.selectedRows.length >= 1) {
                        formData.attendance_regularization_request_id = JSON.stringify(this.state.selectedRows);
                        formData.type = "bulk";
                    } else {
                        formData.attendance_regularization_request_id = this.state.attendance_regularization_request_id;
                    }

                    if (result.value) {
                        formData.remark_by_manager = result.value;
                    } else {
                        formData.remark_by_manager = '';
                    }

                    const headers = apiHeaderJSON;
                    // console.log(formData);
                    axios.post(`${apiURL}Attendance/RegularizeEmployeeAttendance`, formData, {
                        params: {
                            date: currentDateAndTime()
                        },
                        headers
                    })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.message}</strong>`,
                            icon: response.data.success === true ? 'success' : 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                        });
                        this.handleResetForm();
                        this.GetList();
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
                }
            });
        }
        else {
            let formData = {
                attendance_regularization_request_id: this.state.attendance_regularization_request_id,
                remark_by_manager: this.state.remark_by_manager,
            };
            const headers = apiHeaderJSON;
            console.log(formData);
            axios.post(`${apiURL}Attendance/RegularizeEmployeeAttendance`, formData, {
                params: {
                    date: currentDateAndTime()
                },
                headers
            })
                .then((response) => {
                    Swal.fire({
                        title: `<strong>${response.data.message}</strong>`,
                        icon: response.data.success === true ? 'success' : 'error',
                    });
                    this.handleResetForm();
                    this.GetList();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

    };

    RegularizationActionReject = () => {
        Swal.fire({
            title: 'Submit Remark',
            input: 'text',
            inputPlaceholder: 'Enter your Remark',
            showCancelButton: true,
            confirmButtonText: 'Submit',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            // inputValidator: (value) => {
            //     if (!value) {
            //         return 'Remark cannot be empty';
            //     }
            // },
        }).then((result) => {
            if (result.isConfirmed) {
                let formData = {};
                if (this.state.selectedRows.length >= 1) {
                    formData.attendance_regularization_request_id = JSON.stringify(this.state.selectedRows);
                    formData.type = "bulk";
                } else {
                    formData.attendance_regularization_request_id = this.state.attendance_regularization_request_id;
                }

                if (result.value) {
                    formData.remark_by_manager = result.value;
                } else {
                    formData.remark_by_manager = '';
                }
                const { apiURL, apiHeaderJSON } = this.context;
                const headers = apiHeaderJSON;
                console.log(formData);
                axios.post(`${apiURL}Attendance/RejectRegularizationRequest`, formData, {
                    params: {
                        date: currentDateAndTime()
                    },
                    headers
                })
                    .then((response) => {
                        console.log("RegularizationActionReject ~ response", response);
                        Swal.fire({
                            title: `<strong>${response.data.message}</strong>`,
                            icon: response.data.success === true ? 'success' : 'error',
                        });
                        this.setState({ selectedRows: [] }, () => {
                            this.GetList();
                        });

                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });
            }
        });
    };

    handleExcelDownload = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;

        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        axios.get(`${apiURL}Attendance/GetTeamRegularizationReport`, {
            params: {
                limit: this.state.total_records,
                page: 1,
                keyword: this.state.keyword,
                from_date: this.state.from_date,
                to_date: this.state.to_date,
                regularization_status: this.state.selectOption,
            },
            headers,
        }).then((response) => {
            if (response.data.success === true) {
                const rows = response.data.data;


                const data = rows.map(row => ({
                    'Employee Code': row.employee_code,
                    'Employee Name': row.employee_name,
                    'Requested Date': formatDate(row.created_date),
                    'Requested Punch In': JSON.parse(row.regularization_request_remark)?.punch_in_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12)?.includes("NaN") ? "--" : tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12) : "--",
                    'Requested Punch Out': JSON.parse(row.regularization_request_remark)?.punch_out_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12)?.includes("NaN") ? "--" : tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12) : "--",
                    'Punch In': formatTime(row.punch_in_datetime),
                    'Punch Out': formatTime(row.punch_out_datetime),
                    'Shift': convertTo12HourFormat(row.shift_start_time) + " - " + convertTo12HourFormat(row.shift_end_time),
                    'Working Hours': getHoursAndMinutes(row.working_hours),
                    'Deviation': getHoursAndMinutes(row.deviation),
                    'Status': row.regularizationRequestStatus,
                    'Regularization Type': row.regularizationType,
                    'Reason': row.remark_by_manager,
                    'Remark': row.regularized_by_remark,
                }));


                const columns = [
                    { header: 'Employee Code', key: 'Employee Code', width: 30 },
                    { header: 'Employee Name', key: 'Employee Name', width: 30 },
                    { header: 'Requested Date', key: 'Date', width: 20 },
                    { header: 'Requested Punch In', key: 'Requested Punch In', width: 15 },
                    { header: 'Requested Punch Out', key: 'Requested Punch In', width: 15 },
                    { header: 'Punch In', key: 'Punch In', width: 15 },
                    { header: 'Punch Out', key: 'Punch Out', width: 15 },
                    { header: 'Shift', key: 'Shift', width: 20 },
                    { header: 'Working Hours', key: 'Working Hours', width: 20 },
                    { header: 'Deviation', key: 'Deviation', width: 20 },
                    { header: 'Status', key: 'Status', width: 20 },
                    { header: 'Regularization Type', key: 'Regularization Type', width: 20 },
                    { header: 'Reason', key: 'Reason', width: 40 },
                    { header: 'Remark', key: 'Remark', width: 40 },
                ];


                const wb = XLSX.utils.book_new();


                const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });


                ws['!cols'] = columns.map(column => ({ wch: column.width }));


                XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });


                columns.forEach((column, index) => {
                    ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
                });


                XLSX.utils.book_append_sheet(wb, ws, 'Team Regularization');


                // XLSX.writeFile(wb, `AbStartTeamRegularization_(${Date()}).xlsx`);

                const date = new Date();
                const dateString = date.toLocaleDateString();
                const timeString = date.toLocaleTimeString();

                XLSX.writeFile(wb, `AbStartTeamRegularization_(${formatDate(dateString)} ${timeString}).xlsx`);


                Swal.close();


                Swal.fire({
                    title: '<strong>Success</strong>',
                    html: 'Your file has been downloaded successfully.',
                    icon: 'success'
                });
            } else {

                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: response.data.message,
                    icon: 'error'
                });
            }
        })
            .catch((error) => {
                // Close the Swal alert if there is an error
                Swal.close();

                Swal.fire({
                    title: '<strong>Error</strong>',
                    html: error.message,
                    icon: 'error'
                });
            });
    }

    resetForm = () => {
        this.setState({
            employee_leave_id: 0,
            employee_attendance_id: 0,
            employee_id: 0,
            employee_leave_from_date: '',
            employee_leave_to_date: '',
            employee_leave_document: '',
            employee_leave_reason: '',
            employee_leave_to_day_unit: '',
            employee_leave_from_day_unit: '',
            fileName: "",
            fileSize: "",
        });
    }

    handleInputSearch = (e) => {
        this.GetList();
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
         // Store previous keyword before updating state
        const prevKeyword = this.state.keyword;

        this.setState({ [name]: value },
            ()=>{
                if (name === 'keyword' && prevKeyword && !this.state.keyword) {
                    this.GetList();
                }
             }
        );
    }

    handleSelectChange = (name, selectedOption) => {
        this.setState((prevState) => ({
            [name]: selectedOption.value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };


    handlePrev = (ev) => {
        if (this.state.prev === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page - 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleNext = () => {
        if (this.state.next === true) {
            this.setState(
                (prevState) => {
                    return { page: prevState.page + 1 };
                },
                () => {
                    this.GetList();
                }
            );
        }
    };
    handleChange = (e) => {
        this.setState(
            (prevState) => {
                return { page: parseInt(e.target.value, 10) };
            },
            () => {
                this.GetList();
            }
        );
    };

    handleSelectStatus = (selectedOption) => {
        this.setState({ selectOption: selectedOption.value, });
    };


    handleClearAll = () => {
        this.setState(
            {
                rows: [],
                next: false,
                prev: false,
                page: 1,
                limit: 10,
                total_records: 0,
                total_pages: 0,
                loadingList: false,
                keyword: "",
                from_date: "",
                to_date: "",
                selectOption: "",
                month: new Date()?.getMonth(),
            },
            () => {
                this.GetList();
            }
        );
    };

    handleLimitChange = (e) => {
        this.setState(
            {
                limit: parseInt(e.target.value, 10),
                page: 1,
            },
            () => {
                this.GetList();
            }
        );
    };

    handleResetForm = () =>{
        this.setState({
            employee_id: '',
            employee_code: '',
            employee_name: '',
            employee_attendance_id: '',
            attendance_regularization_request_id: '',
            modal_type: false,
            selectedRows: [],
            punch_in_datetime: '',
            punch_out_datetime: '',
        })
        console.log("HandleReset ================>>>>>>>>>>>>>>>>>")
    }

    render() {
        const limitOptions = [10, 25, 50, 100, 200, 500];

       const options = [
            { value: '0', label: 'Pending' },
            { value: '1', label: 'Regularized' },
            { value: '4', label: 'Cancelled' },
            { value: '3', label: 'Rejected' },
        ];


        return (

            this.state.loadingList === false ?
                (<div className="main-content">
                    <div className='page-content'>
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Team Regularization`} primary={`Team Employees`} path={`/TeamEmployees`} />
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="row">
                                                <div className='col-md-3'>
                                                    <label htmlFor="keyword">Employee Name</label>
                                                    <div className="input-group">
                                                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search Name" />
                                                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                                                </div>
                                                <div className='col-md-3'>
                                                    <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                                                </div>
                                                {/* <div className='col-md-2'>
                                                    <div className='position-relative'>
                                                        <div>
                                                            <label>Month</label>
                                                        </div>
                                                        <div style={{ "zIndex": 10, "width": "100%" }} className=' position-absolute'>
                                                            <Select
                                                                options={this.state.monthOptions}
                                                                value={this.state.month ? this.state.monthOptions.find(option => option.value === this.state.month) : null}
                                                                onChange={(selectOption) => this.setState({ month: selectOption?.value })}
                                                                hint={`Select Month`}
                                                                placeholder="Select Month"
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className='col-md-3 position- mb-5'>
                                                    <div><label>Status</label></div>
                                                    <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                        <Select onChange={this.handleSelectStatus}
                                                        options={options}
                                                        placeholder={`Select Status`}
                                                        value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}/>
                                                    </div>
                                                </div>
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Apply Filter</label></div>
                                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleInputSearch}
                                                        className={`w-100 noWrap btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption) ? 'disabled' : ''}`}>
                                                        <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                        Filter
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "1"},()=>{this.handleInputSearch()})}} 
                                                    disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                                                    loading={this.state.loadingFilter==="1"} loadingMessage='Loading' 
                                                    buttonName={"Filter"}  type='info' icon='ri-filter-3-fill' />
                                                </div>
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Clear Filter</label></div>
                                                    {/* <button
                                                        type="button"
                                                        className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.from_date && !this.state.selectOption && !this.state.to_date) ? 'disabled' : ''}`}
                                                        onClick={this.handleClearAll}
                                                    >
                                                        <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 "></i> 
                                                        Clear
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.setState({loadingFilter: "2"},()=>{this.handleClearAll()})}} 
                                                    disabled={!this.state.keyword && !this.state.from_date && !this.state.selectOption && !this.state.to_date}
                                                    loading={this.state.loadingFilter==="2"} loadingMessage='Loading'
                                                    buttonName={"Clear"}  type='secondary' icon='ri-database-2-line' />
                                                </div>
                                                { this.state.decodedData?.includes(6) && (
                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                    <div><label>Export Excel</label></div>
                                                    {/* <button
                                                        type="button"
                                                        onClick={this.handleExcelDownload}
                                                        className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                                        <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                        Export Excel
                                                    </button> */}
                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={()=>{ this.handleExcelDownload() }} 
                                                    disabled={this.state.rows.length === 0}
                                                    buttonName={"Export Excel"}  type='success' icon='ri-file-excel-2-line' />
                                                </div>)}
                                            </div>
                                            <div className="row mt-3">
                                                {/* <div className='col-md-3'>
                                                    <div className="row">
                                                    <div style={{width:"13%"}} className='col-md-2'>
                                                            <div>
                                                                <label>Apply Filter</label>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={this.handleInputSearch}
                                                                className={`w-100 btn btn-info btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.to_date === '' && this.state.selectOption === '') ? 'disabled' : ''}`}>
                                                                <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                                                Filter
                                                            </button>
                                                        </div>
                                                        <div style={{width:"10%"}} className='col-md-2'>
                                                            <div>
                                                                <label>Clear Filter</label>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className={`btn btn-secondary btn-label waves-effect waves-light ${(!this.state.keyword && !this.state.month && this.state.from_date === '' && this.state.selectOption === '' && this.state.to_date === '') ? 'disabled' : ''}`}
                                                                onClick={this.handleClearAll}
                                                            >
                                                                <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 "></i> Clear</button>
                                                        </div>

                                                    </div>

                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="row">
                                                        <div className='col-md-12'>
                                                            <div>
                                                                <label>Export Excel</label>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={this.handleExcelDownload}
                                                                className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn btn-info btn-label waves-effect waves-light`}>
                                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                                Export Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div> */}
                                                {this.state.selectedRows.length !== 0 ?
                                                    (
                                                    // <div className='col-md-3'>
                                                        <div className="row">
                                                            <>
                                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                                    <div>
                                                                        <label>Approve</label>
                                                                    </div>
                                                                    {/* <button
                                                                        type="button"
                                                                        onClick={(e) => this.RegularizationActionAccept(e)}
                                                                        className={`btn btn-success btn-label waves-effect waves-light `}>
                                                                        <i className="bx bx-check-circle label-icon align-middle fs-20 me-2"></i>
                                                                        Approve
                                                                    </button> */}
                                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={(e) => this.RegularizationActionAccept(e)} 
                                                                    buttonName={"Approve"}  type='success' icon='bx bx-check-circle' />
                                                                </div>
                                                                <div className='col-lg-2 col-md-3 col-6 '>
                                                                    <div><label>Reject</label></div>
                                                                    {/* <button
                                                                        type="button"
                                                                        className={`btn btn-danger btn-label waves-effect waves-light`}
                                                                        onClick={(e) => this.RegularizationActionReject(e)}
                                                                    >
                                                                        <i className="bx bx-x-circle label-icon align-middle fs-20 me-2"></i>
                                                                        Reject
                                                                    </button> */}
                                                                    <SubmitButton otherClasses='w-100 noWrap' onClick={(e) => this.RegularizationActionReject(e)} 
                                                                    buttonName={"Reject"}  type='danger' icon='bx bx-x-circle' />
                                                                </div>
                                                            </>
                                                    </div>
                                                    // </div>
                                                    ) : ""
                                                }
                                            </div>
                                        </div>
                                        {/* style={{ width: '235%', minWidth: '600px' }} */}
                                        <div className="card-body">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                <table style={{ minwidth: '100%' }} className={` position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-left`}>
                                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            {this.state.multi_action === "1" ?
                                                                <th width="100" className='noWrap text-center'>Select
                                                                    <div className="d-flex justify-content-center align-items-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            className={` form-check-input`}
                                                                            checked={this.state.selectedRows?.length >= 1 && this.state.checkAll}
                                                                            onChange={(e) => this.handleSelectAllCheckboxChange(e.target.checked)}
                                                                            disabled={this.state?.rows?.length < 1}
                                                                        />
                                                                    </div>
                                                                </th> : null
                                                            }

                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Employee Code</th>
                                                            <th className=' text-center noWrap'>Employee Name</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Application Date</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Requested Punch In</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Requested Punch Out</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Punch In</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Punch Out</th>
                                                            <th className=' text-center'>Shift </th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Working Hours</th>
                                                            {/* <th style={{ textWrap: "nowrap" }} className=' text-center'>Deviation</th> */}
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Status</th>
                                                            <th style={{ textWrap: "nowrap" }} className=' text-center'>Regularization Type</th>
                                                            <th className=' text-center '>Reason</th>
                                                            <th className=' text-center '>Remark</th>
                                                            {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                                                            <th className=' text-center'>Action</th>)}
                                                        </tr>
                                                    </thead>
                                                    {this.state.rows.length === 0 ? (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={15}>
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    ) :
                                                        <tbody>
                                                            {this.state.rows.map((row, idx) => {
                                                                return (
                                                                    <tr key={row.attendance_regularization_request_id}>
                                                                        {this.state.multi_action === "1" ?
                                                                            <td >
                                                                                <div className="d-flex justify-content-center align-items-center">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className={`${row.regularization_request_status === 0 ? getDaysDifference(formatDate(row.created_date)) >= this.state.rz_data.days_for_rm_action ? "disabled bg-light" : "" : row.regularizationRequestStatus === "Regularized" ? "disabled bg-success" : "disabled bg-danger"} form-check-input`}
                                                                                        checked={this.state.selectedRows?.some(selectedRow => selectedRow === row.attendance_regularization_request_id)}
                                                                                        onChange={() => row.regularization_request_status === 0 && this.handleCheckboxChange(row.attendance_regularization_request_id)}
                                                                                        disabled={row.regularization_request_status === 1 || (getDaysDifference(formatDate(row.created_date)) >= this.state.rz_data.days_for_rm_action)}
                                                                                    />
                                                                                </div>
                                                                            </td> : null
                                                                        }

                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.employee_code}</td>
                                                                        <td >{row.employee_name}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{formatDate(row.created_date)}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{JSON.parse(row.regularization_request_remark)?.punch_in_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12)?.includes("NaN") ? "--" : tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_in_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{JSON.parse(row.regularization_request_remark)?.punch_out_datetime ? tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12)?.includes("NaN") ? "--" : tableFormatDateAndTime(JSON.parse(row.regularization_request_remark)?.punch_out_datetime, 12) : "--"}</td>
                                                                        {/* <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.check_in_time ? convertTo12HourFormat(row.check_in_time) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row?.check_out_time ? convertTo12HourFormat(row.check_out_time) : "--"}</td> */}
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.punch_in_datetime ? tableFormatDateAndTime(row.punch_in_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.punch_out_datetime ? tableFormatDateAndTime(row.punch_out_datetime, 12) : "--"}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{convertTo12HourFormat(row.shift_start_time) + ", " + convertTo12HourFormat(row.shift_end_time)}</td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.working_hours ? getHoursAndMinutes(row.working_hours) : "--"}</td>
                                                                        {/* <td style={{ textWrap: "nowrap" }} className=' text-center'>
                                                                            <span className={isNegativeDeviation(row.deviation) ? 'text-danger' : ''}>{row.deviation && row?.deviation !== "NaN" ? getHoursAndMinutes(row.deviation) : "--"}</span>
                                                                        </td> */}
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'><span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus}</span></td>
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>{row.regularizationType}</td>
                                                                        <td className={`${row.remark_by_employee?.length > 30 ? " textEllipse" : "noWrap"}`} >{row.remark_by_employee ? row.remark_by_employee : "--"}</td>
                                                                        <td className={`${row.regularized_by_remark?.length > 30 ? " textEllipse" : "noWrap"}`} >{row.regularized_by_remark ? row.regularized_by_remark : "--"}</td>
                                                                        {(this.state.decodedData?.includes(1) || this.state.decodedData?.includes(3)) && (
                                                                        <td style={{ textWrap: "nowrap" }} className=' text-center'>
                                                                            {row.regularization_request_status === 0 && getDaysDifference(formatDate(row.created_date)) <= this.state.rz_data.days_for_rm_action ? (
                                                                                <div className='d-flex justify-content-around align-items-center'>
                                                                                     {this.state.decodedData?.includes(3) &&(
                                                                                    <button type="button" className="btn btn-sm btn-outline-primary" disabled={this.state.selectedRows.length >= 1} onClick={() => this.GetInfo(row,idx)}>
                                                                                        Approve
                                                                                    </button>
                                                                                     )}
                                                                                      {this.state.decodedData?.includes(3) &&(
                                                                                    <button type="button" className="btn btn-sm btn-danger mx-3" disabled={this.state.selectedRows.length >= 1} onClick={() => this.setState({ employee_id: row.employee_id, employee_code: row.employee_code, employee_name: row.employee_name, employee_attendance_id: row.employee_attendance_id, attendance_regularization_request_id: row.attendance_regularization_request_id, selectedRows: [] }, (prevState) => this.RegularizationActionReject())}>
                                                                                        Reject
                                                                                    </button>)}
                                                                                </div>) :
                                                                                    (row.regularization_request_status != 0 && this.state.decodedData?.includes(1)) ? (
                                                                                        <button type="button" className="btn btn-sm btn-info" onClick={() => this.setState( { employee_id: row.employee_id, employee_attendance_id: row.employee_attendance_id, attendance_regularization_request_id: row.attendance_regularization_request_id, modal_type: 2, }, () => this.GetRegularizationLogs() ) }>
                                                                                        Details
                                                                                        </button>
                                                                                    ) : (
                                                                                        "Expired!"
                                                                                    )}
  
                                                                        </td>)}
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>}


                                                </table>
                                            </div>
                                            <div className="d-flex justify-content-between bg-light align-items-center flex-wrap w-100 py-2 px-2">
                                                {/* <button
                                                    disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                                                    type="button"
                                                    onClick={() => this.handlePrev()}
                                                    className={`btn btn-warning btn-label waves-effect waves-light`}
                                                >
                                                    <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                                    Previous
                                                </button> */}
                                                <SubmitButton onClick={()=>{ this.handlePrev() }} 
                                                disabled={this.state.prev === false && this.state.loadingList === false}
                                                buttonName={"Previous"}  type='warning' icon='ri-arrow-left-line' />
                                                <SubmitButton otherClasses='d-md-none d-block' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                disabled={this.state.next === false && this.state.loadingList === false}
                                                buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                                <div className="col-md-4 col-12 my-md-0 my-2" style={{ display: "flex", alignItems: "center" }}>
                                                    {
                                                        <small>
                                                            Total Records: {this.state.total_records} |
                                                            Total Pages: {this.state.total_pages} |
                                                            Current Page: {this.state.page}
                                                        </small>
                                                    }
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                        {Array.from(
                                                            { length: this.state.total_pages },
                                                            (_, i) => (
                                                                <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                                    Page {i + 1}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                                <div className="col-md-2">
                                                    <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                                                        {limitOptions.map((option) => (
                                                            <option key={option} value={option}>
                                                                Limit {option}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <button disabled={ this.state.next === false && this.state.loadingList === false ? true : false }
                                                type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}>
                                                    <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                                    Next
                                                </button> */}
                                                <SubmitButton otherClasses='d-md-block d-none' iconSide='right' onClick={()=>{ this.handleNext() }} 
                                                disabled={this.state.next === false && this.state.loadingList === false}
                                                buttonName={"Next"}  type='primary' icon='ri-arrow-right-line' />
                                            </div>
                                        </div>
                                        {/* <div className="modal show"  tabIndex={-1} aria-modal="true">
                                            <div className={`modal-dialog ${this.state.modal_type === 2 ? " modal-xl " : "modal-lg"}`}>
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title" id="exampleModalgridLabel">Regularize Attendance</h5>
                                                        <button type="button" className="btn-close" ref={this.closeRef} data-bs-dismiss="modal" aria-label="Close" />
                                                    </div> */}
                                        {this.state.modal_type && (
                                            <div id="myModal" className="modal show" tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}} aria-labelledby="teamRegularizationLable" aria-hidden="true">
                                                <div className="m-auto mt-3 w-modal">
                                                    <div className="modal-content">
                                                        <div className="modal-header pb-0">
                                                            <h5 className="modal-title">Regularize Attendance</h5>
                                                            <button onClick={() => { this.handleResetForm();}} className="btn-close" aria-label="Close" />
                                                        </div>
                                                        <div className="modal-body pt-0">
                                                            {this.state.modal_type === 1 &&
                                                                <form onSubmit={(e)=> this.RegularizationActionAccept(e)}>
                                                                    <div className="row mb-3">
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="employee_code" className="form-label">Employee Code</label>
                                                                            <input
                                                                                disabled
                                                                                type="text"
                                                                                id="employee_code"
                                                                                name="employee_code"
                                                                                className="form-control"
                                                                                value={this.state.employee_code}
                                                                            />
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="employee_name" className="form-label">Employee Name</label>
                                                                            <input
                                                                                disabled
                                                                                type="text"
                                                                                id="employee_name"
                                                                                name="employee_name"
                                                                                className="form-control"
                                                                                value={this.state.employee_name}
                                                                            />
                                                                        </div>
                                                                        {!this.state.punch_in_datetime?.includes("NaN") ?
                                                                            <div className="col-md-6">
                                                                                <label htmlFor="punch_in_datetime" className="form-label">Punch In</label>
                                                                                <input
                                                                                    disabled
                                                                                    type="text"
                                                                                    id="punch_in_datetime"
                                                                                    name="punch_in_datetime"
                                                                                    className="form-control"
                                                                                    value={this.state.punch_in_datetime}
                                                                                    onChange={this.handleInputChange}
                                                                                    required={true}
                                                                                />
                                                                            </div> : null}
                                                                        {!this.state.punch_out_datetime?.includes("NaN") && (
                                                                            <div className="col-md-6">
                                                                                <label htmlFor="punch_out_datetime" className="form-label">Punch Out</label>
                                                                                <input
                                                                                    disabled
                                                                                    type="text"
                                                                                    id="punch_out_datetime"
                                                                                    name="punch_out_datetime"
                                                                                    className="form-control"
                                                                                    value={this.state.punch_out_datetime}
                                                                                    onChange={this.handleInputChange}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        <div className="col-md-12 mt-3">
                                                                            <label htmlFor="remark_by_manager" className="form-label">Remark</label>
                                                                            <textarea
                                                                                type="text"
                                                                                id="remark_by_manager"
                                                                                placeholder="Enter remark"
                                                                                name="remark_by_manager"
                                                                                className="form-control"
                                                                                value={this.state.remark_by_manager}
                                                                                onChange={this.handleInputChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex justify-content-end">
                                                                        <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                                                                            <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Approve </button>
                                                                    </div>
                                                                </form>}
                                                            {this.state.modal_type === 2 && (
                                                                <>
                                                                    {this.state.logs_data?.length !== 0 ? (
                                                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                                                            <table style={{ width: '110%', minWidth: '1200px' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                                                                <thead className='bg-primary text-light bg-gradient'>
                                                                                    <tr>
                                                                                        <th className='noWrap'>Action Date</th>
                                                                                        <th className='noWrap'>Action By</th>
                                                                                        <th className='noWrap'>Requested Punch In</th>
                                                                                        <th className='noWrap'>Requested Punch Out</th>
                                                                                        <th className='noWrap'>Regularization Type</th>
                                                                                        <th className='noWrap'>Reason</th>
                                                                                        <th className='noWrap'>Remark</th>
                                                                                        { this.state.decodedData?.includes(3) ||   this.state.decodedData?.includes(1) && ( 
                                                                                        <th className='noWrap'>Action Status</th>)}
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {this.state.logs_data?.map(log => (
                                                                                        <tr key={log.attendance_regularization_request_log_id}>
                                                                                            <td className='noWrap'>{formatDate(log.created_date)}</td>
                                                                                            <td>{log.employee_name}</td>
                                                                                            <td className='noWrap'>{formatDate(JSON.parse(log.regularization_request_remark).punch_in_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark).punch_in_datetime)}</td>
                                                                                            <td className='noWrap'>{formatDate(JSON.parse(log.regularization_request_remark).punch_out_datetime) + ' - ' + formatTime(JSON.parse(log.regularization_request_remark).punch_out_datetime)}</td>
                                                                                            <td>{log.regularizationType}</td>
                                                                                            <td className={`${JSON.parse(log.regularization_request_remark).remark?.length > 30 ? " textEllipse" : "noWrap"}`} >{JSON.parse(log.regularization_request_remark).remark}</td>
                                                                                            <td >{log.regularized_by_remark || '---'}</td>
                                                                                        { this.state.decodedData?.includes(3) ||   this.state.decodedData?.includes(1) && ( 
                                                                                            <td className='noWrap'><span className={`badge bg-${log.regularizationRequestClasses}`}>{log.regularizationRequestStatus}</span></td>
                                                                                        )}
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    ) : (
                                                                        <div>No Logs Found ...!</div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ) : <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

        );
    }
}

export default withRouter(TeamRegularization);
